import { createFileRoute } from '@tanstack/react-router'

import { FinalizationReasonsSection } from '@/features/organization/finalization-reasons-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/motivos-finalizacao')({
  component: MotivosFinalizacaoTab,
})

function MotivosFinalizacaoTab() {
  const { currentOrgId } = useAuth()
  return <FinalizationReasonsSection orgId={currentOrgId} />
}
